import React from 'react';

var AwardWinning = function AwardWinning(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M16.342 10.368V5.12c0-.005-2.802-.01-8.405-.015-.005 0-.01 1.755-.016 5.263-.048 3.171 1.973 5.264 4.21 5.264 2.134 0 4.213-2.098 4.211-5.264zm-4.21 7.369c-3.541 0-6.315-4.21-6.315-7.823V5.12c0-1.17.949-2.12 2.12-2.12h8.39c1.171 0 2.12.95 2.12 2.12v5.048c0 3.358-2.837 7.569-6.315 7.569zm-1.053 2.105v-3.158a1.053 1.053 0 0 1 2.105 0v3.158h2.105a1.053 1.053 0 1 1 0 2.105H8.974a1.053 1.053 0 1 1 0-2.105h2.105zm5.85-7.718a1.053 1.053 0 1 1 .931-1.888c.177.087.368.132.566.132.763 0 1.41-.692 1.41-1.579 0-.886-.647-1.578-1.41-1.578a1.053 1.053 0 0 1 0-2.106c1.958 0 3.516 1.665 3.516 3.684 0 2.02-1.558 3.685-3.516 3.685-.524 0-1.033-.12-1.497-.35zm-9.617 0c-.464.23-.972.35-1.496.35-1.958 0-3.516-1.665-3.516-3.685s1.558-3.684 3.516-3.684a1.053 1.053 0 0 1 0 2.106c-.763 0-1.41.692-1.41 1.578 0 .887.647 1.58 1.41 1.58.198 0 .389-.046.566-.133a1.053 1.053 0 1 1 .93 1.888z",
    fill: "currentColor",
    fillRule: "nonzero"
  }));
};

AwardWinning.defaultProps = {
  role: "img",
  viewBox: "0 0 24 24"
};
import iconHandler from './hoc';
export { AwardWinning as icon };
export default iconHandler(AwardWinning);


//////////////////
// WEBPACK FOOTER
// ./~/@jsluna/icons/dist/AwardWinning.js
// module id = 585
// module chunks = 0